export const APP_ROLES = ['admin', 'dept_admin', 'member', 'auditor'] as const;
export type AppRole = (typeof APP_ROLES)[number];

export const ROLE_LABELS: Record<AppRole, string> = {
  admin: '企业管理员',
  dept_admin: '部门管理员',
  member: '成员',
  auditor: '审计与合规',
};
